// extracted by mini-css-extract-plugin
export default {"hovered":"xsocial_hovered__KANYX","bw_circle":"xsocial_bw_circle__PLpvF","bw_stars":"xsocial_bw_stars__xvER2","stars":"xsocial_stars__oZddD"};